import React from 'react'

export default function BlogDetails() {
  return (
    <div>BlogDetails</div>
  )
}
